// extracted by mini-css-extract-plugin
export default {"fileBlock":"TypeFile_fileBlock__We7R+","textBlock":"TypeFile_textBlock__tYGlq","textContent":"TypeFile_textContent__+8PWR"};